import { Icon, Text } from '@kanda-libs/ks-design-library';

export interface EnquiryLandingButtonProps {
  onClick: () => void;
  icon: string;
  text: string;
  isLoading?: boolean;
}

const EnquiryLandingButton: React.FunctionComponent<EnquiryLandingButtonProps> =
  function ({ onClick, icon, text, isLoading = false }) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="flex flex-row gap-x-4 border border-purple-400 bg-neutral-50 hover:bg-purple-50 px-8 py-6 rounded-xl shadow-card group"
      >
        <Icon
          icon={icon}
          isLoading={isLoading}
          stroke="purple-400"
          size={48}
          className="min-w-12"
        />
        <Text
          text={text}
          isLoading={isLoading}
          className="text-18-22-em text-neutral-700 group-hover:text-purple-400 my-auto text-left"
        />
      </button>
    );
  };

export default EnquiryLandingButton;
